import { DataWizardAct, TextActVM } from 'civil-status/view-models/step-form';

export const transformText = (data: DataWizardAct): TextActVM => {
  return {
    text: data.evento?.composizioneCompleta || '',
    isEditText: data.statoCivile?.flagTestoEditabile === '1',
  };
};
